import { Html } from '@change-corgi/design-system/html';
import { Box } from '@change-corgi/design-system/layout';
import type { DesignSystemStyleObject } from '@change-corgi/design-system/theme';
import { Heading } from '@change-corgi/design-system/typography';

import { ComboStory } from './components/ComboStory';
import { HeroFeed } from './components/HeroFeed';
import { ImpactBox } from './components/ImpactBox';
import { PetitionMedia } from './components/PetitionMedia';
import { PromoteOrShareActions } from './components/PromoteOrShareActions';
import { usePageBody } from './hooks/usePageBody';

// translations are using classes from the old DS...
// we're reproducing those using these styles
const HTML_STYLES: DesignSystemStyleObject = {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'& p+p': {
		mt: 16,
	},
};

export function PageBody() {
	const {
		data: { heading, subHeading1, showImpactBox, heroFeed },
	} = usePageBody();

	return (
		<Box
			sx={{
				display: 'grid',
				gridTemplateColumns: ['1fr', heroFeed.show ? '1fr 42%' : null],
				gap: 24,
			}}
		>
			<Box
				backgroundColor="primary-white"
				sx={{
					boxShadow: '0 2px 3px 0 rgba(54, 49, 53, 0.2)',
					borderRadius: 'standard',
					overflow: 'hidden',
					maxWidth: heroFeed.show ? undefined : 620,
					mx: heroFeed.show ? undefined : 'auto',
				}}
			>
				<PetitionMedia />
				<Box px={[16, 32]} pt={[16, 32]} pb={32}>
					<Box data-qa="description">
						<Heading as="h1" size="h2" mb={16}>
							{heading}
						</Heading>
						<Box mb={24}>
							<Html as="div" html={subHeading1} mb={16} noContentStyles sx={HTML_STYLES} />
							<ComboStory />
						</Box>
					</Box>
					{showImpactBox && (
						<ImpactBox mb={24}>
							{heroFeed.show && (
								<HeroFeed
									items={heroFeed.items}
									animationStartSize={2}
									sx={{
										display: ['block', 'none'],
										height: 90,
									}}
									noPadding
									backgroundColor="neutral-grey50"
									mt={16}
									data-qa="hero-feed-mobile-impact"
								/>
							)}
						</ImpactBox>
					)}
					{heroFeed.show && !showImpactBox && (
						<HeroFeed
							items={heroFeed.items}
							animationStartSize={2}
							sx={{
								display: ['block', 'none'],
								height: 90,
							}}
							noPadding
							mb={24}
							data-qa="hero-feed-mobile"
						/>
					)}
					<PromoteOrShareActions />
				</Box>
			</Box>
			{heroFeed.show && (
				<HeroFeed
					items={heroFeed.items}
					animationStartSize={10}
					backgroundColor="primary-white"
					sx={{
						display: ['none', 'block'],
						boxShadow: '0 2px 3px 0 rgba(54, 49, 53, 0.2)',
						borderRadius: 'standard',
						height: '100%',
					}}
					data-qa="hero-feed-desktop"
				/>
			)}
		</Box>
	);
}
